import { Link } from "react-router-dom";
import { ArrowRight, Check, Minus, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Placeholder } from "@/components/Placeholder";

export const ServiceCard = ({ service, index = 0, compact = false }) => (
  <Reveal delay={index * 0.06} className="h-full">
    <article data-testid={`service-card-${service.slug}`} className="card card-hover flex h-full flex-col overflow-hidden">
      <header className="border-b border-slate-200 p-6 md:p-8">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="label-xs">Service {service.numeral}</p>
            <h3 className="mt-2 font-display text-xl font-bold tracking-tight md:text-2xl">{service.title}</h3>
          </div>
          {!compact && <span className="shrink-0 whitespace-nowrap rounded-full bg-brand-soft px-3 py-1 text-xs font-semibold text-brand">Request a Quote</span>}
        </div>
        <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">{compact ? service.short : service.description}</p>
      </header>

      {!compact && (
        <div className="grid gap-8 p-6 md:grid-cols-2 md:p-8">
          <div>
            <p className="label-xs">What's included</p>
            <ul className="mt-3 space-y-2.5">
              {service.included.map((it) => (
                <li key={it} className="flex gap-2.5 text-sm leading-snug text-slate-700">
                  <Check size={16} className="mt-0.5 shrink-0 text-forest" />
                  {it}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="label-xs">Not included</p>
            <ul className="mt-3 space-y-2.5">
              {service.notIncluded.map((it) => (
                <li key={it} className="flex gap-2.5 text-sm leading-snug text-slate-600">
                  <Minus size={16} className="mt-0.5 shrink-0 text-slate-400" />
                  {it}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-start gap-2.5 rounded-lg bg-cream p-4">
              <Clock size={16} className="mt-0.5 shrink-0 text-brand" />
              <div>
                <p className="label-xs">Typical delivery</p>
                <p className="mt-1 text-sm text-slate-700"><Placeholder field={service.timeframe} /></p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mt-auto flex flex-col gap-3 border-t border-slate-200 bg-cream/60 px-6 py-5 sm:flex-row sm:items-center sm:justify-between md:px-8">
        <p data-testid={`service-card-pricing-${service.slug}`} className="text-sm text-slate-600">
          Pricing: <span className="font-semibold text-ink">{service.pricing}</span>
        </p>
        <div className="flex flex-wrap gap-2.5">
          <Link to={service.path} data-testid={`service-card-details-${service.slug}`} className="btn-outline px-4 py-2.5 text-sm">Full Details</Link>
          <Link to={`/contact?service=${service.slug}`} data-testid={`service-card-quote-${service.slug}`} className="btn-primary px-4 py-2.5 text-sm">
            Request a Quote <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </article>
  </Reveal>
);
